// Corrections + standards — a real, binding editorial policy.
export const editorialStandards: { title: string; body: string }[] = [
  {
    title: "Synthesis, not republishing",
    body: "We read primary sources — manufacturer specs, federal databases, and retailer listings — and write our own explanation. We do not copy other publishers' articles or paraphrase them line by line.",
  },
  {
    title: "Never fabricate",
    body: "If a spec, price, or study cannot be traced to a real source, it does not go on the page. We do not invent numbers, reviews, test results, or credentials.",
  },
  {
    title: "Honest omission over invention",
    body: "When data is missing, we say so or leave it out — we never fill a gap with a guess. An empty field is more trustworthy than a fabricated one.",
  },
  {
    title: "No pay-for-placement",
    body: "Rankings and recommendations follow data and editorial criteria. No brand or retailer can buy a higher position, a better score, or a review.",
  },
  {
    title: "Transparent affiliate model",
    body: "We earn commissions on some outbound retailer links, disclosed site-wide. Those commissions never influence what we rank, score, or recommend.",
  },
  {
    title: "Report a correction",
    body: "Report a possible error with the page link and a source that supports the correction. Product specifications, prices and editorial statements can all be reported.",
  },
]
